<template>
  <div style="display:none" />
</template>

<script setup lang="ts">
import { useMessage } from 'naive-ui'

// 把 naive-ui 的 message 实例挂到 window.$message，
// 供 axios 拦截器等非组件上下文做全局提示（错误/权限警告）使用。
;(window as any).$message = useMessage()
</script>
